import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Mapper {
  mapCollection<TSource, TDest>(
    source: TSource[],
    mapConfig: Record<keyof TDest, (source: TSource) => TDest[Extract<keyof TDest, string>]>
  ) {
    const result: TDest[] = [];

    for (const item of source) {
      const mappedItem = this.map<TSource, TDest>(item, mapConfig);
      result.push(mappedItem);
    }
    return result;
  }

  map<TSource, TDest>(
    source: TSource,
    mapConfig: Record<keyof TDest, (source: TSource) => TDest[Extract<keyof TDest, string>]>
  ): TDest {
    if (source === null) {
      return source as unknown as TDest;
    }

    const result = {} as TDest;

    for (const key in mapConfig) {
      if (!(key in mapConfig)) {
        continue;
      }

      const destKey = key as Extract<keyof TDest, string>;
      const mapper = mapConfig[key];

      result[destKey] = mapper(source);
    }

    return result;
  }
}
